// extracted by mini-css-extract-plugin
export default {"productGallery":"GG-z","inQuickShop":"HG-z"};